function cepFormat(cep: string): string {
  if (!cep) {
    return '';
  }

  return cep.replace(/\D/g, '').replace(/(\d{5})(\d{3})/g, '$1-$2');
}

export { cepFormat };
